import {
	Block,
	Button,
	palette,
	Rating,
	spacing,
	Typography,
	useBreakpoints,
} from "@stepapp/ui";
import { useRouter } from "expo-router";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Platform, StyleSheet } from "react-native";

type Props = {
	rating?: number;
	numberOfReviews?: number;
};

const FloatingButton = ({ rating, numberOfReviews }: Props) => {
	const { navigate } = useRouter();
	const { t } = useTranslation();
	const { md } = useBreakpoints();

	const handleNavigateToDashboard = useCallback(() => {
		navigate("/");
	}, [navigate]);

	return (
		<Block
			justifyEnd
			row
			paddingHorizontal={md ? 5 : 2}
			paddingVertical={2}
			style={styles.content}
		>
			<Block flex={1}>
				<Rating rating={rating} t={t} />

				<Typography variant="paragraph">
					{`${t("screens.reviews.numberOfReviews")}: ${numberOfReviews}+`}
				</Typography>
			</Block>

			<Block flex={2} marginLeft={2.5}>
				<Button
					label={t("screens.reviews.orderCleaning")}
					onPress={handleNavigateToDashboard}
					type="primary"
					variant="default"
				/>
			</Block>
		</Block>
	);
};

export default React.memo(FloatingButton);

const styles = StyleSheet.create({
	content: {
		backgroundColor: palette.common.white,
		borderTopLeftRadius: spacing.radius,
		borderTopRightRadius: spacing.radius,
		bottom: 0,
		left: 0,
		margin: "auto",
		maxWidth: 1180,
		right: 0,
		width: "100%",
		zIndex: 2,
		...Platform.select({
			default: {
				elevation: 5,
				shadowColor: "#000",
				shadowOffset: { width: 0, height: 4 },
				shadowOpacity: 0.2,
				shadowRadius: 13,
				position: "absolute",
			},
			web: {
				boxShadow: "0px -4px 20px rgba(0, 0, 0, 0.2)",
				// biome-ignore lint/suspicious/noExplicitAny: web styles
				position: "fixed" as any,
			},
		}),
	},
});
